module.exports = __webpack_public_path__ + "static/media/Sale.3e5e8aec.jpg";